export default {"src":"/_next/static/media/white_heart_filled.59f5d060.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};